import {gql} from '@apollo/client'

export const GET_TICKETS = gql`
  query tickets(
    $search: String
    $status: String
    $channel: String
    $priority: String
    $ticketTypeId: ID
    $assignmentType: String
    $assignedUserId: ID
    $assignedGroupId: ID
    $createdById: ID
    $createdAfter: Date
    $createdBefore: Date
    $dueAfter: DateTime
    $dueBefore: DateTime
    $includeArchived: Boolean
    $onlyOverdue: Boolean
    $onlyUnassigned: Boolean
    $inboxMode: String
    $pendingInbox: Boolean
    $first: Int
    $offset: Int
  ) {
    tickets(
      search: $search
      status: $status
      channel: $channel
      priority: $priority
      ticketTypeId: $ticketTypeId
      assignmentType: $assignmentType
      assignedUserId: $assignedUserId
      assignedGroupId: $assignedGroupId
      createdById: $createdById
      createdAfter: $createdAfter
      createdBefore: $createdBefore
      dueAfter: $dueAfter
      dueBefore: $dueBefore
      includeArchived: $includeArchived
      onlyOverdue: $onlyOverdue
      onlyUnassigned: $onlyUnassigned
      inboxMode: $inboxMode
      pendingInbox: $pendingInbox
      first: $first
      offset: $offset
    ) {
      totalCount
      items {
        id
        title
        observations
        channel
        externalReference
        status
        priority
        assignmentType
        dueAt
        firstResponseAt
        slaBreachedAt
        isArchived
        isDeleted
        isOverdue
        createdAt
        updatedAt
        closedAt
        ticketType {
          id
          name
          isActive
        }
        assignedUser {
          id
          firstName
          lastName
          email
        }
        assignedGroup {
          id
          name
        }
        createdBy {
          id
          firstName
          lastName
          email
        }
        updatedBy {
          id
          firstName
          lastName
          email
        }
        firstResponseBy {
          id
          firstName
          lastName
          email
        }
      }
    }
  }
`

export const GET_TICKET_BY_ID = gql`
  query ticketById($id: ID!) {
    ticketById(id: $id) {
      id
      title
      observations
      channel
      externalReference
      status
      priority
      assignmentType
      dueAt
      firstResponseAt
      slaBreachedAt
      isArchived
      isDeleted
      isOverdue
      createdAt
      updatedAt
      closedAt
      ticketType {
        id
        name
        description
        isActive
      }
      assignedUser {
        id
        firstName
        lastName
        email
      }
      assignedGroup {
        id
        name
      }
      createdBy {
        id
        firstName
        lastName
        email
      }
      updatedBy {
        id
        firstName
        lastName
        email
      }
      firstResponseBy {
        id
        firstName
        lastName
        email
      }
      closedBy {
        id
        firstName
        lastName
      }
      notes {
        id
        comment
        createdAt
        author {
          id
          firstName
          lastName
          email
        }
      }
      attachments {
        id
        file
        originalName
        contentType
        fileSize
        createdAt
        uploadedBy {
          id
          firstName
          lastName
          email
        }
      }
      statusHistory {
        id
        previousStatus
        newStatus
        changedAt
        comment
        changedBy {
          id
          firstName
          lastName
          email
        }
      }
      changeLogs {
        id
        fieldName
        oldValue
        newValue
        changedAt
        comment
        changedBy {
          id
          firstName
          lastName
          email
        }
      }
    }
  }
`

export const GET_TICKET_TYPES = gql`
  query ticketTypes($isActive: Boolean) {
    ticketTypes(isActive: $isActive) {
      id
      name
      description
      isActive
    }
  }
`

export const GET_TICKET_METRICS = gql`
  query ticketMetrics($includeArchived: Boolean) {
    ticketMetrics(includeArchived: $includeArchived) {
      openCount
      overdueCount
      unassignedCount
      myAssignedCount
      groupAssignedCount
      resolvedLast7Days
      avgResolutionHours
    }
  }
`

export const GET_TICKET_DASHBOARD = gql`
  query ticketDashboard($includeArchived: Boolean, $days: Int) {
    ticketDashboard(includeArchived: $includeArchived, days: $days) {
      todaySubmitted
      todayResolved
      kpis {
        avgFirstResponseHours
        avgResolutionHours
        resolutionFirstTouchRate
        customerSatisfaction
      }
      statusCounts {
        status
        count
      }
      topSolvers {
        userId
        fullName
        email
        solvedCount
      }
      trend {
        day
        submitted
        resolved
      }
    }
  }
`
